import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'
import { debounce } from '~/utils/timing'

export default class SearchFiltersController extends Controller {
  static values = {
    delay: { type: Number, default: 400 }
  }

  connect () {
    this.debouncedSubmit = debounce(() => this.submit(), this.delayValue)
  }

  submitOnInput (event) {
    if (this.#isSearchField(event.target)) this.submitDebounced()
  }

  submitImmediately () {
    this.submit()
  }

  submitOnEnter (event) {
    event.preventDefault()
    this.submit()
  }

  submitDebounced () {
    this.debouncedSubmit()
  }

  submit () {
    if (this.element.requestSubmit) {
      this.element.requestSubmit()
      return
    }

    this.element.submit()
  }

  #isSearchField (target) {
    if (!target) return false

    const isSearchInput = target instanceof window.HTMLInputElement && target.type === 'search'
    return isSearchInput || target.name === 'search'
  }
}

stimulus.register('search-filters', SearchFiltersController)
